import type { EffectParams } from '@swf/core/store';

enum AppData {
  LiveRaceTerms = 'ldr_tc',
  UKRaceTerms = 'ukgc_tc'
}

const fetchAppData = async (payload: undefined, { dispatch, request }: EffectParams) => {
  const { body } = await request({
    service: 'casino.player.appdata',
    body: [AppData.UKRaceTerms, AppData.LiveRaceTerms]
  });
  const ukResult = body.find((appdata: { key: string }) => appdata.key === AppData.UKRaceTerms);
  const liveResult = body.find((appdata: { key: string }) => appdata.key === AppData.LiveRaceTerms);
  await dispatch.casino.set({
    UKTermsAccepted: !!ukResult?.value,
    liveRacesTermsAccepted: !!liveResult?.value
  });
};

export default fetchAppData;
